import { MessageSquareText } from "lucide-react";
import { ProductShell } from "@tribunalea/ui";

const navigation = [
  {
    label: "Lexia",
    items: [
      {
        to: "/",
        label: "Preguntar a Justiniano",
        icon: MessageSquareText,
      },
    ],
  },
];

const portalUrl = import.meta.env.DEV
  ? "http://localhost:3000/portal"
  : "https://tribunalea.com/portal";

const accountUrl = import.meta.env.VITE_ACCOUNT_URL || (
  import.meta.env.DEV
    ? "http://localhost:5175"
    : "https://account.tribunalea.com"
);

const products = [
  {
    name: "Praxis",
    href: import.meta.env.VITE_PRAXIS_URL || (
      import.meta.env.DEV
        ? "http://localhost:5173"
        : "https://praxis.tribunalea.com"
    ),
  },
  {
    name: "Instrumenta",
    href: import.meta.env.VITE_INSTRUMENTA_URL || (
      import.meta.env.DEV
        ? "http://localhost:5174"
        : "https://instrumenta.tribunalea.com"
    ),
  },
  {
    name: "Lexia",
    href: import.meta.env.VITE_LEXIA_URL || (
      import.meta.env.DEV
        ? "http://localhost:5176"
        : "https://lexia.tribunalea.com"
    ),
  },
];

export function AppShell({ authEnabled, accountControls, children }) {
  return (
    <ProductShell
      productName="Lexia"
      products={products}
      navigation={navigation}
      portalUrl={portalUrl}
      accountSettingsHref={`${accountUrl}/creditos`}
      accountControls={accountControls}
      demo={!authEnabled}
    >
      {children}
    </ProductShell>
  );
}
